import Vue from 'vue';

Vue.component('GContainer', () => import('./components/grid/GContainer.vue'));
Vue.component('GRow', () => import('./components/grid/GRow.vue'));
Vue.component('GRows', () => import('./components/grid/GRows.vue'));
Vue.component('GColumn', () => import('./components/grid/GColumn.vue'));
